export default __webpack_public_path__ + "static/media/juice-bottle-lockup-mobile.667b4df3.png";